import { render, staticRenderFns } from "./studios.vue?vue&type=template&id=4a751ee3&scoped=true"
import script from "./studios.vue?vue&type=script&lang=js"
export * from "./studios.vue?vue&type=script&lang=js"
import style0 from "./studios.vue?vue&type=style&index=0&id=4a751ee3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a751ee3",
  null
  
)

export default component.exports